import {
  ComposedChart, Line, XAxis, YAxis, Tooltip, ReferenceArea, ResponsiveContainer,
} from "recharts";
import { tierVar } from "./TierBadge";

/* 12-month Monthly Achievement trend with tier bands shaded as zones,
   so crossing into Silver is visually obvious. */
export const OemTrendChart = ({ series, bands, dataKey = "score", height = 190, testId }) => {
  const data = (series || []).map((s) => ({
    label: s.label || s.month_label || s.month,
    score: s[dataKey] ?? s.monthly_achievement ?? s.avg,
    tier: s.tier,
  }));
  const sorted = [...(bands || [])].sort((a, b) => a.min - b.min);
  const zones = sorted.map((b, i) => ({
    tier: b.tier, y1: b.min, y2: i + 1 < sorted.length ? sorted[i + 1].min : 1000,
  }));
  const yMin = Math.max(0, Math.min(400, ...data.map((d) => d.score || 400)) - 60);
  return (
    <div style={{ height }} data-testid={testId}>
      <ResponsiveContainer width="100%" height="100%">
        <ComposedChart data={data} margin={{ top: 6, right: 8, bottom: 0, left: -18 }}>
          {zones.map((z) => (
            <ReferenceArea key={z.tier} y1={Math.max(z.y1, yMin)} y2={z.y2}
              fill={`hsl(var(${tierVar(z.tier)}))`} fillOpacity={0.07}
              label={{ value: z.tier, position: "insideTopRight",
                       fill: `hsl(var(${tierVar(z.tier)}))`, fontSize: 9, opacity: 0.85 }} />
          ))}
          <XAxis dataKey="label" tick={{ fontSize: 10 }} tickLine={false} axisLine={false} />
          <YAxis domain={[yMin, 1000]} tick={{ fontSize: 10 }} tickLine={false} axisLine={false} width={52} />
          <Tooltip
            contentStyle={{ fontSize: 11, borderRadius: 8 }}
            formatter={(v, _n, e) => [`${v}${e?.payload?.tier ? ` · ${e.payload.tier}` : ""}`, "Score"]} />
          <Line type="monotone" dataKey="score" stroke="hsl(var(--cx-navy))" strokeWidth={2}
            dot={{ r: 3, fill: "hsl(var(--cx-navy))" }} isAnimationActive={false} />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};
